import React from "react";
import Doctor from "../Assets/dba-server-room.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleCheck,
  faCalendarCheck,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate  } from "react-router-dom";
import "../Styles/BookAppointment.css";

function BookAppointment() {
  const navigate = useNavigate();

  const handleBookAppointmentClick = () => {
    navigate("/appointment");
  };

  return (
    <div className="ba-section">
      <div className="ba-text-content">
        <h3 className="ba-title">
          <span>Why Choose TechiesHub</span>
        </h3>
        <p className="ba-description">
            Our-Compnay commenced business in 2016 after three years of designing and working on a solution for its first client in South Africa. Our-Compnay is made up of professionals with a good blend of financial and software expertise. Founders have a combined experience of 28 years providing solutions to the financial services sector in Africa.
        </p>

        <p className="ba-checks ba-check-first">
          <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#1E8FFD" }} /> Best Database Administrators
        </p>
        <p className="ba-checks">
          <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#1E8FFD" }} /> Emergency Care
        </p>
        <p className="ba-checks">
          <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#1E8FFD" }} /> 24/7 Support
        </p>
        <p className="ba-checks ba-check-last">
          <FontAwesomeIcon icon={faCircleCheck} style={{ color: "#1E8FFD" }} /> Enrollment Easy and Quick
        </p>

        <button
          className="text-appointment-btn"
          type="button"
          onClick={handleBookAppointmentClick}
        >
          <FontAwesomeIcon icon={faCalendarCheck} /> Book Appointment
        </button>
      </div>

        <div className="ba-image-content">
            <img src={Doctor} alt="Database Administrator" className="ba-image1" />
        </div>
    </div>
  );
}

export default BookAppointment;
